import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faArrowRight, faArrowLeft, faBroom, faAdd, faSave } from '@fortawesome/free-solid-svg-icons';
import './StockLoad.css'
import { Tooltip } from 'react-tooltip';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import GoCast from '../../Images/GoCast.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
////////////////////////////////////////

const LoadForm = () => {

    const [isLoading, setIsLoading] = useState(false); // Loading GIF

    // Takes Parametres from URL and save it to Variables
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const Key2 = queryParams.get('Key2');
    const Key3 = queryParams.get('Key3');
    const Key4 = queryParams.get('Key4');
    const Key5 = queryParams.get('Key5');
    const Company = queryParams.get('Company');
    // Returns Dynamic Parameter from TruckForm :truckId
    const { loadID } = useParams();
    const [newLoadID, setNewLoadId] = useState('');


    // Option Panel visibility
    const [panel1Visible, setPanel1Visible] = useState(true);
    // Advanced Panel visibility
    const [panel2Visible, setPanel2Visible] = useState(true);

    //        API CODE FOR Form
    const [formApiData, setFormApiData] = useState({});
    const [truckApiData, setTruchApi] = useState([]);
    const [selectedTruck, setSelectedTruck] = useState('');
    const [resourceApiData, setResourceApiData] = useState([]);
    const [driverApiData, setDriverApiData] = useState([]);
    const [FromToSiteApiData, setFromToSiteApiData] = useState([]);
    const [FromToApiData, setFromToApiData] = useState([]);
    const [BinApiData, setBinApiData] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState('');
    // Add new
    const [addNew, setAddNew] = useState(false);
    //update fields
    const [projectID, setProjectID] = useState('');
    const [fromSite, setFromSite] = useState('');
    const [toSite, setToSite] = useState('');
    const [bin, setBin] = useState('');
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');
    const [loadStatus, setLoadSatus] = useState('Open');
    const [loadDate, setLoadDate] = useState('');
    const [loadTime, setLoadTime] = useState('');
    const [loadType, setLoadType] = useState('Issue Load');
    const [loadCondition, setLoadCondition] = useState('Internal Truck');
    //update fields 2
    const [truckID, setTruckID] = useState('');
    const [plateNum, setPlateNum] = useState('');
    const [driverName, setDriverName] = useState('');
    const [capacity, setCapacity] = useState('');
    const [length, setLLength] = useState('');
    const [volume, setVolume] = useState('');
    const [comment, setComment] = useState('');
    const [resource, setResource] = useState('');
    const [transporter, SetTransporterName] = useState('');
    const [driverMobile, setDriverMobile] = useState('');
    const [loadCount, setLoadCount] = useState('');
    const [width, SetWidth] = useState('');
    const [height, setHeight] = useState('');
    const [foreman, setForeman] = useState('');
    const [employeeName, setEmployeeName] = useState('');

    //       UPDATE 
    const [modifiedData, setModifiedData] = useState({});
    //        API CODE FOR Grid
    const [tableApiData, setTableApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

    const fetchData = async () => {

        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrlGRID = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103As?$filter= Key1 eq '${loadID}'`; // Adjust the URL as needed
        const apiUrlFORM = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103s(${Company},${loadID},,,,)`;
        const apiUrlTruckDrpDwn = `https://77.92.189.102/iitprecastvertical/api/v1/BaqSvc/IIT_TruckDropDown`;
        const apiUrlDriver = `https://77.92.189.102/iitprecastvertical/api/v1/BaqSvc/IIT_DriverName`;
        const apiUrlFromToSite = `https://77.92.189.102/iitprecastvertical/api/v1/Erp.BO.Plantsvc/List?$filter= Company eq 'PRECAST'`;
        const apiUrlFromTo = `https://77.92.189.102/iitprecastvertical/api/v1/Erp.BO.Warehsesvc/List?$filter= Company eq 'PRECAST'`;
        try {
            ////////////////////////// Form Data /////////////////////////////////
            if (loadID != null && !addNew) {
                setIsLoading(true); // Load GIF
                const resp = await fetch(apiUrlFORM, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });

                if (!resp.ok) {
                    throw new Error('Network response was not ok');
                }
                const formData = await resp.json();
                console.log(formData.ShortChar08);
                setFormApiData(formData); // Set the state with the response object directly
                setIsLoading(false); // Load GIF
                handleResourceList(formData.ShortChar08);
                handleBinList(formData.Character04);
                setLoadType(formData.ShortChar01);
                setLoadCondition(formData.ShortChar04);
                ////////////////////////// Table Grid Data /////////////////////////////////
                const response = await fetch(apiUrlGRID, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                // Check if data is an object and contains the 'value' property which is an array
                if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                    setTableApiData(data.value);
                } else {
                    console.error('API response does not contain the expected array in the "value" property:', data);
                }
            }
            else {
                setAddNew(true);
            }
            // get the drop down data of the trucks
            const Truckresp = await fetch(apiUrlTruckDrpDwn, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!Truckresp.ok) {
                throw new Error('Network response was not ok');
            }
            const TruckIdData = await Truckresp.json();
            setTruchApi(TruckIdData.value); // Set the state with the response object directly

            // get the drop down data of the drivers
            const driverResp = await fetch(apiUrlDriver, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!driverResp.ok) {
                throw new Error('Network response was not ok');
            }
            const driverData = await driverResp.json();
            setDriverApiData(driverData.value); // Set the state with the response object directly

            // get the drop down data of the FromToSite
            const fromToSiteResp = await fetch(apiUrlFromToSite, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!fromToSiteResp.ok) {
                throw new Error('Network response was not ok');
            }
            const fromToSiteData = await fromToSiteResp.json();
            setFromToSiteApiData(fromToSiteData.value); // Set the state with the response object directly

            // get the drop down data of the FromToSite
            const fromToResp = await fetch(apiUrlFromTo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!fromToResp.ok) {
                throw new Error('Network response was not ok');
            }
            const fromToData = await fromToResp.json();
            setFromToApiData(fromToData.value); // Set the state with the response object directly

        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }

    };
    useEffect(() => {

        fetchData();

    }, []); // Fetch data on component mount

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = tableApiData.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>{item.Company}</td>
                <td>{item.Key1}</td>
                <td>{item.ChildKey1}</td>
                <td>{item.Character01}</td>
                <td>{item.Character02}</td>
                <td>{item.Character03}</td>
                <td>{item.Character04}</td>
                <td>{item.Number01}</td>
                <td>{item.ShortChar07}</td>
                <td>{item.GlobalUD103A}</td>
                <td>{item.GlobalLock}</td>
            </tr>
        ));
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(tableApiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    //  Update 
    const saveData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager';
        const password = 'manager';
        if (addNew) {
            const apiUrl = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103s`;
            const newLoad = {
                "Company": "PRECAST",
                "Key1": newLoadID,
                "Key2": "",
                "Key3": "",
                "Key4": "",
                "Key5": "",
                //transporter name
                "Character01": transporter,
                //driver name
                "Character02": driverName,
                //driver mobile
                "Character03": driverMobile,
                //to
                "Character04": to,
                //bin
                "Character05": bin,
                //from
                "Character06": from,
                // "Character07": "",
                // "Character08": "",
                //resource
                "Character09": resource,
                // "Character10": "",
                // "Number01": "0.000000000",
                //load time
                // "Number02": loadTime,
                // // "Number03": "0.000000000",
                // // "Number04": "0.000000000",
                // // "Number05": "0.000000000",
                // //capacity
                // "Number06": capacity,
                // //volume
                // "Number07": volume,
                // // "Number08": "0.000000000",
                // // "Number09": "0.000000000",
                // // length
                // "Number10": length,
                //load date
                "Date01": "2024-05-02T00:00:00",
                // "Date01": loadDate,
                // "Date02": "2024-05-02T00:00:00",
                //load type
                "ShortChar01": loadType,
                // "ShortChar02": "",
                //load status
                "ShortChar03": loadStatus,
                //load condition
                "ShortChar04": loadCondition,
                //project
                // "ShortChar05": "",
                // "ShortChar06": "",
                // "ShortChar07": "",

                //truck id
                "ShortChar08": truckID,
                // "ShortChar09": "",
                // "ShortChar10": "",
                // "EmployeeID_c": "",
                // "EmployeeName_c": "",
                "Comments_c": comment,
                "FromSite_c": fromSite,
                "ToSite_c": toSite

            };
            console.log(newLoad)
            try {
                const response = await axios.post(apiUrl, newLoad, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                setAddNew(false);
                console.log('Data saved successfully:', response.data);
                setIsLoading(false); // Loading GIF
                fetchData();
                navigate(`/stockload/loadform/${newLoadID}`, { replace: true });
                fetchData();
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
            }
            setIsLoading(false); // Loading GIF

        }
        else {
            const apiUrl = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103s(${Company},${loadID},,,,)`;
            try {
                console.log('modified data:' + modifiedData);
                const response = await axios.patch(apiUrl, modifiedData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
                setIsLoading(false); // Load GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
                setIsLoading(false); // Load GIF
            }
        }
    };
    const addNewInside = () => {
        console.log("Add button clicked!");
        setAddNew(true);
        // Reset the modifiedData state to clear all fields
        setModifiedData({});
        setTableApiData([]);
        setTruchApi([]);
        setDriverApiData([]);
        setFromToApiData([]);
        setFromToSiteApiData([]);
        setLoadSatus('Open');
        setLoadType('Issue Load');
        setLoadCondition('Internal Truck');
        handleResourceList('');
        handleBinList('');
        setCapacity('');
        setVolume('');
        setLLength('');
        setLoadCount('');
        SetWidth('');
        setHeight('');
        setDriverName('');
        setDriverMobile('');
        // Optionally, if you want to reset the apiData state as well, uncomment the following line
        setFormApiData({}); // Uncomment this line if you also want to reset the apiData state

        fetchData();
    };
    // const saveChildData = async () => {
    //     const username = 'manager';
    //     const password = 'manager';
    //     const apiUrl = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UserCodesSvc/UDCodes?$filter= CodeTypeID eq '${approvalID}'`;
    //     const newRow = {
    //         "Company": "PRECAST",
    //         "CodeTypeID": approvalID,
    //         "CodeID": codeID,
    //         "IsActive": active,
    //         "CodeDesc": childDescription,
    //         "LongDesc": "EX",
    //         "CreateDate": "2023-11-07T00:00:00",
    //         "CreateUser": "MANAGER",
    //         "codeTypeIDDescCodeTypeDesc": approvalID,
    //         "FinalApproval_c": finalApproval
    //     };
    //     console.log(newRow)
    //     try {
    //         const response = await axios.post(apiUrl, newRow, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Basic ' + btoa(username + ":" + password)
    //             }
    //         });
    //         setShowNewEmptyRow(false)
    //         fetchData();
    //         console.log('Data saved successfully:', response.data);
    //         // Toast Notifcation
    //         setTimeout(() => {
    //             toast.success("Data Saved Successfully");
    //         }, 10);
    //     } catch (error) {
    //         console.error('Error:', error.message);
    //         // Toast Notifcation
    //         setTimeout(() => {
    //             toast.error("Failed To Save");
    //         }, 10);
    //     }

    // };
    const handleInputChange = (e, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setModifiedData(prevState => ({
            ...prevState,
            [field]: newValue
        }));
    };

    // Toggle Option Panel visibility
    const togglePanel1Visibility = () => {
        setPanel1Visible(!panel1Visible);
    }
    // Toggle Advanced Panel visibility
    const togglePanel2Visibility = () => {
        setPanel2Visible(!panel2Visible);
    }
    const handleResourceList = async (truck) => {
        console.log(truck + "event");
        setTruckID(truck);
        setSelectedTruck(truck);
        const username = 'manager';
        const password = 'manager';
        console.log(selectedTruck + "selected truck");
        const apiUrl = `https://77.92.189.102/iitprecastvertical/api/v1/BaqSvc/IIT_ResourceDropDown?$filter= UD102_Key1 eq '${truck}'`;

        try {
            const Resourceresp = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!Resourceresp.ok) {
                throw new Error('Network response was not ok');
            }
            const ResourceData = await Resourceresp.json();
            setResourceApiData(ResourceData.value); // Set the state with the response object directly
            setResource(ResourceData.value[0].UD102A_ChildKey1);
        } catch (error) {
            console.error('Error:', error.message);
        }
    }

    const handleBinList = async (toBins) => {
        console.log(toBins + "event bin");
        setSelectedWarehouse(toBins);
        setTo(toBins);
        const username = 'manager';
        const password = 'manager';
        console.log(selectedWarehouse + "selected warehouse");
        const apiUrlBin = `https://77.92.189.102/iitprecastvertical/api/v1/Erp.BO.WhseBinSvc/List?$filter= Company eq 'PRECAST' and WarehouseCode eq '${toBins}'`;

        // get the drop down data of the Bin
        try {
            const binResp = await fetch(apiUrlBin, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!binResp.ok) {
                throw new Error('Network response was not ok');
            }
            const binData = await binResp.json();
            setBinApiData(binData.value); // Set the state with the response object directly}
        } catch (error) {
            console.error('Error:', error.message);
        }
    }

    // Navigation To Another Page
    const navigate = useNavigate();
    const GoBack = () => {
        navigate(-1); // Navigates back to the previous page
    };

    const handleSelectChange = (e, stateSetter, fieldName) => {
        const newValue = e.target.value;
        if (addNew) {
            stateSetter(newValue);
        } else {
            setFormApiData(prevState => ({
                ...prevState,
                [fieldName]: newValue
            }));
            setModifiedData(prevState => ({
                ...prevState,
                [fieldName]: newValue
            }));
            if (fieldName === 'ShortChar01' || fieldName === 'ShortChar04') {
                stateSetter(newValue);
            }
        }
        if (fieldName === 'Character04') {
            handleBinList(e.target.value);
        }
        if (fieldName === 'ShortChar08') {
            handleResourceList(e.target.value);
        }

    };


    // Converts a Date object to a YYYY-MM-DD string for display in the input
    function formatDateForInput(date) {
        const offset = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() - offset * 60 * 1000);
        return adjustedDate.toISOString().split('T')[0];
    }

    // Adjusts a Date object to the local timezone
    function adjustDateToLocalTimezone(date) {
        const offset = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() + offset * 60 * 1000);
        return adjustedDate;
    }

    return (
        <div className='card panelcard'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className='DetailsForm'>
                <div className="card-header">
                    <button type="button" className="toggle-table-icon" onClick={GoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <h2 className='panel-title-report'>Stock Loading</h2>
                    <div className='ctrl-btns-report'>
                        <button className="btn" id='add' onClick={addNewInside}>
                            <FontAwesomeIcon icon={faAdd} />
                        </button>
                        <Tooltip
                            anchorSelect="#add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='Print' onClick={saveData}>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#Print"
                            content="Save"
                            place='bottom'
                        />
                        <button className="btn" id='Clear' onClick={GoBack}>
                            {/* <FontAwesomeIcon icon={faBroom} /> */}
                            <svg className='myBroom' width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="0.744">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M22.4524 1.92267C22.7452 2.21557 22.7452 2.69044 22.4524 2.98333L16.1393 9.29634C15.9927 9.11579 15.8353 8.94105 15.6673 8.77297C15.4768 8.58252 15.2778 8.40582 15.0715 8.24289L21.3917 1.92267C21.6846 1.62978 22.1595 1.62978 22.4524 1.92267Z" fill="#000"></path>
                                    <path d="M15.0277 9.34728C12.7822 7.10177 9.14153 7.10177 6.89601 9.34728L6.65198 9.59131L14.7837 17.723L15.0277 17.479C17.2733 15.2335 17.2733 11.5928 15.0277 9.34728Z" fill="#000"></path>
                                    <path d="M1.8838 12.9659L5.49664 10.5573L13.8177 18.8784L11.4091 22.4912C11.2845 22.6782 11.0826 22.7994 10.859 22.8215C10.6354 22.8437 10.4137 22.7644 10.2548 22.6055L1.76949 14.1202C1.61061 13.9613 1.53133 13.7396 1.55347 13.516C1.57561 13.2924 1.69684 13.0905 1.8838 12.9659Z" fill="#000"></path>
                                </g>
                            </svg>
                        </button>
                        <Tooltip
                            anchorSelect="#Clear"
                            content="Clear Form"
                            place='bottom'
                        />

                    </div>
                </div>
                {/* Panel 1  */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel1Visibility}>
                            <FontAwesomeIcon icon={panel1Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Parent Details
                        </h5>
                    </div>
                    {panel1Visible && (
                        <div className="table-responsive-md">
                            <div className='TruckForm'>
                                <form>
                                    <div className="row row1">
                                        <div className="col-3 leftCol">
                                            <div className="label-input-box">
                                                <label>Load</label>
                                                <input type="text" autocomplete="off" id="endDate" name="daterange" className="Elementidinput-report" defaultValue={formApiData.Key1}
                                                    onChange={(e) => addNew ? setNewLoadId(e.target.value) : formApiData.Key1} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Project</label>
                                                <input type="text" autocomplete="off" id="endDate" name="daterange" className="Elementidinput-report" defaultValue={formApiData.ShortChar05} onChange={(e) => addNew ? setProjectID(e.target.value) : handleInputChange(e, 'ShortChar05')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>From Site</label>
                                                <select
                                                    className="Elementidinput-report"
                                                    type="text"
                                                    value={formApiData.FromSite_c}
                                                    onChange={(e) => handleSelectChange(e, setFromSite, 'FromSite_c')}
                                                >
                                                    {FromToSiteApiData.map((option, index) => (
                                                        <option key={index} value={option.Plant}>{option.Name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>From</label>
                                                <select
                                                    className="Elementidinput-report"
                                                    type="text"
                                                    value={formApiData.Character06}
                                                    onChange={(e) => handleSelectChange(e, setFrom, 'Character06')}
                                                >
                                                    {FromToApiData.map((option, index) => (
                                                        <option key={index} value={option.WarehouseCode}>{option.Description}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>To</label>

                                                <select
                                                    className="Elementidinput-report"
                                                    type="text"
                                                    value={formApiData.Character04}
                                                    onChange={(e) => handleSelectChange(e, setTo, 'Character04')}
                                                >
                                                    {FromToApiData.map((option, index) => (
                                                        <option key={index} value={option.WarehouseCode}>{option.Description}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>PO Num</label>
                                                <input type="text" autocomplete="off" id="endDate" name="daterange" className="Elementidinput-report" disabled defaultValue={formApiData.Number04} />
                                            </div>

                                        </div>
                                        <div className="col-3 midCol">
                                            <div className="label-input-box">
                                                <label>Load Status</label>
                                                <input type="text" autocomplete="off" id="endDate" name="daterange" className="Elementidinput-report" defaultValue={formApiData.ShortChar03} onChange={(e) => addNew ? setLoadSatus(e.target.value) : handleInputChange(e, 'ShortChar03')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Load Date</label>
                                                <input
                                                    type="date"
                                                    autocomplete="off"
                                                    id="endDate"
                                                    name="daterange"
                                                    className="Elementidinput-report"
                                                    defaultValue={
                                                        formApiData.Date01
                                                            ? formatDateForInput(new Date(formApiData.Date01))
                                                            : ''
                                                    }
                                                    onChange={(e) => {
                                                        const selectedDate = new Date(e.target.value);
                                                        const adjustedDate = adjustDateToLocalTimezone(selectedDate);
                                                        addNew ? setLoadDate(formatDateForInput(adjustedDate)) : handleInputChange(e, 'Date01', formatDateForInput(adjustedDate));
                                                    }}
                                                />
                                            </div>
                                            <div className="label-input-box">
                                                <label>To Site:</label>
                                                <select
                                                    className="Elementidinput-report" type="text"
                                                    value={formApiData.ToSite_c}
                                                    onChange={(e) => handleSelectChange(e, setToSite, 'ToSite_c')}
                                                >
                                                    {FromToSiteApiData.map((option, index) => (
                                                        <option key={index} value={option.Plant}>{option.Name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Bin</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist"
                                                    value={formApiData.Character05}
                                                    onChange={(e) => handleSelectChange(e, setBin, 'Character05')}
                                                >
                                                    {BinApiData.map((option, index) => (
                                                        <option key={index} value={option.BinNum}>{option.Description}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Load Time:</label>
                                                <input type="time" autocomplete="off" className="Elementidinput-report" onChange={(e) => addNew ? setLoadTime(e.target.value) : handleInputChange(e, 'Number02')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>PO Line</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number05} />

                                            </div>
                                        </div>
                                        <div className="col-3 rightColForm">

                                            <div className='loadTypeCont'>
                                                <label className='chkbox-title' >Load Type :</label>
                                                <div className='chkbox-container'>
                                                    {/* Return Load */}
                                                    <input className="form-check-input " type="radio" id="Delivery_Trip1" name='Delivery_Trip' checked={loadType === "Issue Load" ? true : false}
                                                        //  onChange={(e) => addNew ? setLoadType("Issue Load") : handleInputChange(e, 'ShortChar01')} 
                                                        value="Issue Load"
                                                        onChange={(e) => handleSelectChange(e, setLoadType, 'ShortChar01')} />
                                                    <label className="form-check-label " for="Delivery_Trip1">Delivery Trip
                                                    </label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input className="form-check-input " type="radio" id="Delivery_Trip2" name='Delivery_Trip' checked={loadType === "Return Load" ? true : false}
                                                        // onChange={(e) => addNew ? setLoadType("Return Load") : handleInputChange(e, 'ShortChar01')} />
                                                        value="Return Load"
                                                        onChange={(e) => handleSelectChange(e, setLoadType, 'ShortChar01')} />
                                                    <label className="form-check-label " for="Delivery_Trip2">Retrurn Trip
                                                    </label>
                                                </div>

                                            </div>
                                            <div className='loadTypeCont'>
                                                <label className='chkbox-title' >Load Condition :</label>
                                                <div className='chkbox-container'>
                                                    <input className="form-check-input " type="radio" id="Load_Condition1" name='Load_Condition' checked={loadCondition === "External Supply" ? true : false}
                                                        value="External Supply"
                                                        onChange={(e) => handleSelectChange(e, setLoadCondition, 'ShortChar04')} />
                                                    <label className="form-check-label " for="Load_Condition1">External Supply</label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input className="form-check-input " type="radio" id="Load_Condition2" name='Load_Condition' checked={loadCondition === "Internal Truck" ? true : false}
                                                        value="Internal Truck"
                                                        onChange={(e) => handleSelectChange(e, setLoadCondition, 'ShortChar04')} />
                                                    <label className="form-check-label " for="Load_Condition2">Internal Truck</label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input className="form-check-input " type="radio" id="Load_Condition3" name='Load_Condition' checked={loadCondition === "Ex-Factory" ? true : false}
                                                        value="Ex-Factory"
                                                        onChange={(e) => handleSelectChange(e, setLoadCondition, 'ShortChar04')} />
                                                    <label className="form-check-label " for="Load_Condition2">Ex-Factory</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="row row2">
                                        <span>
                                            <label className='section-title'>Truck Details</label>
                                        </span>
                                        <div className="col-3 leftCol">
                                            <div className="label-input-box">
                                                <label>Truck ID</label>
                                                <select
                                                    className="Elementidinput-report" type="text"
                                                    name="optionlist"
                                                    value={formApiData.ShortChar08}
                                                    onChange={(e) => handleSelectChange(e, setTruckID, 'ShortChar08')}
                                                >
                                                    {truckApiData.map((option, index) => (
                                                        <option key={index} value={option.UD102_Key1}>{option.UD102_Character01}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Plate NO</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.ShortChar07}
                                                    onChange={(e) => addNew ? setPlateNum(e.target.value) : handleInputChange(e, 'ShortChar07')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Driver Name</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist"
                                                    value={formApiData.Character02}
                                                    onChange={(e) => handleSelectChange(e, setDriverName, 'Character02')}
                                                >
                                                    {driverApiData.map((option, index) => (
                                                        <option key={index} value={option.Driver_DriverID}>{option.Driver_Name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Capacity</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number06}
                                                    onChange={(e) => addNew ? setCapacity(e.target.value) : handleInputChange(e, 'Number06')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Length</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number10}
                                                    onChange={(e) => addNew ? setLLength(e.target.value) : handleInputChange(e, 'Number10')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Volume</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number07}
                                                    onChange={(e) => addNew ? setVolume(e.target.value) : handleInputChange(e, 'Number07')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Foreman / In charge</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.EmployeeID_c}
                                                    onChange={(e) => addNew ? setForeman(e.target.value) : handleInputChange(e, 'EmployeeID_c')} />
                                            </div>


                                        </div>
                                        <div className="col-3 midCol">
                                            <div className="label-input-box">
                                                <label>Resource</label>
                                                {/* <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Character09} /> */}
                                                <select
                                                    className="Elementidinput-report" type="text"
                                                    name="optionlist" id='truckID'
                                                    value={formApiData.Character09}
                                                    onChange={(e) => addNew ? setResource(e.target.value) : handleInputChange(e, 'Character09')}
                                                >
                                                    {resourceApiData.map((option, index) => (
                                                        <option key={index} value={option.UD102A_ChildKey1}>{option.UD102A_Character01}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Transporter Name</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Character01}
                                                    onChange={(e) => addNew ? SetTransporterName(e.target.value) : handleInputChange(e, 'Character01')}
                                                />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Driver Mobile</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Character03}
                                                    onChange={(e) => addNew ? setDriverMobile(e.target.value) : handleInputChange(e, 'Character03')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Loaded:</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number01}
                                                    onChange={(e) => addNew ? setLoadCount(e.target.value) : handleInputChange(e, 'Number01')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Width:</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number09}
                                                    onChange={(e) => addNew ? SetWidth(e.target.value) : handleInputChange(e, 'Number09')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Height:</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number08}
                                                    onChange={(e) => addNew ? setHeight(e.target.value) : handleInputChange(e, 'Number08')} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Employee Name:</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" Value={formApiData.EmployeeName_c}
                                                    onChange={(e) => addNew ? setEmployeeName(e.target.value) : handleInputChange(e, 'EmployeeName_c')} />
                                            </div>

                                        </div>
                                        <div className="col-3 rightColAdditional">
                                            <div className="label-input-box">
                                                <label>Comments</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Comments_c}
                                                    onChange={(e) => addNew ? setComment(e.target.value) : handleInputChange(e, 'Comments_c')} />
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
                {/* Panel 2 */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel2Visibility}>
                            <FontAwesomeIcon icon={panel2Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Stock Loading
                        </h5>
                    </div>
                    {panel2Visible && (
                        <div className="table-responsive-md">
                            <div className='DetailsForm'>
                                <div className="table-responsive">
                                    <div className="scrollable-table-body">
                                        <table className="table table-bordered">
                                            {/* Table content */}
                                            <thead className='table-primary'>
                                                <tr className='bg-primary text-white'>
                                                    <th>Company</th>
                                                    <th>Load</th>
                                                    <th>Line No</th>
                                                    <th>Part Num</th>
                                                    <th>Element ID</th>
                                                    <th>From Warehouse</th>
                                                    <th>From Bin</th>
                                                    <th>Quantity</th>
                                                    <th>UOM</th>
                                                    <th>GlobalUD103A</th>
                                                    <th>GlobalLock</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderTableRows()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="pagination">
                                    <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                    </button>
                                    <button onClick={goToNextPage} disabled={currentPage === Math.ceil(tableApiData.length / itemsPerPage)}>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </button>
                                </div>

                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};

export default LoadForm;